import find from "lodash/fp/find";
import constants from "../../core/constants";
import moment from "moment";

class ReportPageTransform {
  constructor(Lists) {
    "ngInject";
    this.Lists = Lists.all;
    this.captainRatingFields = [
      { name: "name", title: "Name" },
      { name: "level0", title: "X > 4.7" },
      { name: "level1", title: "4.0 < X < 4.7" },
      { name: "level2", title: "3.5 < X < 4.0" },
      { name: "level3", title: "1.0 < X < 3.5" },
    ];
  }

  justify(data) {
    const format = (data) => {
      const listItem = find((item) => item.name === data.type)(
        this.Lists[data.type]
      );
      data.createdAt = moment(data.createdAt).format(constants.dateFormat);

      const formatData = (item) => {
        const listObj = this.Lists.dailyReportKeys.find(
          (l) => l.name === item.field
        );
        item.title = listObj && listObj.title;

        return item;
      };

      if (data.query) {
        data.startDate = moment(data.query.from_date).format(
          constants.dateTimeFormat
        );
        data.endDate = moment(data.query.to_date).format(
          constants.dateTimeFormat
        );
        data.date = moment(data.query.date).format(constants.dateFormat);
      }
      data.fields = this[`${data.type}Fields`];
      data.itemState = listItem ? listItem.state : null;

      data.items = data.data && data.data.map(formatData);

      return data;
    };
    const formatted = format(data);
    return formatted;
  }
}

export default ReportPageTransform;



// WEBPACK FOOTER //
// ./src/pages/report/report.transforms.js